<script setup lang="ts">
import { ref } from "vue";
import DictionaryTypes from "@/domains/home/services/configurations/views/dictionary/DictionariyTypes.vue";
import WordLibrary from "@/domains/home/services/configurations/views/dictionary/WordLibrary.vue";

const currentRoute = ref<string>('library')

const select = (route: string) => {
  currentRoute.value = route
}
</script>

<template>
  <div class="flex flex-col">
    <div class="grid grid-cols-12">
      <div class="col-span-2">
        <span
              @click="select('library')"
              :class="[(currentRoute === 'library') ? 'menu-pill-active' : 'menu-pill']">
            Word Library
          </span>
        <span
            @click="select('types')"
            :class="[(currentRoute === 'types') ? 'menu-pill-active' : 'menu-pill']">
            Dictionary Types
          </span>
      </div>
      <div class="col-span-10">
        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-12">
            <WordLibrary v-if="currentRoute === 'library'" />
            <DictionaryTypes v-if="currentRoute === 'types'"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
